// URL validation - checks if the string is a valid HTTP/HTTPS URL
export const isValidUrl = (str: string): boolean => {
    try {
        const url = new URL(str);
        return url.protocol === 'http:' || url.protocol === 'https:';
    } catch {
        return false;
    }
};

// GitHub URL validation - checks if the URL is from github.com
export const isValidGitHubUrl = (str: string): boolean => {
    if (!isValidUrl(str)) return false;
    try {
        const url = new URL(str);
        return url.hostname === 'github.com' || url.hostname === 'www.github.com';
    } catch {
        return false;
    }
};
